import { Navigate, useParams } from "react-router-dom";
import AdminDashboardNew from "../../views/admin/dashboard/AdminDashboardNew";
import AddSubscription from "../../views/admin/subscription/add";
import SubscriptionList from "../../views/admin/subscription/list";
import AddProduct from "../../views/admin/products/add";
import ProductList from "../../views/admin/products/list";
import OrderManagement from "../../views/admin/orderManagement";
import EditProduct from "../../views/admin/products/edit";
import ExistingCategory from "../../views/admin/category/existingCategory";
import AdminProductDetails from "../../views/admin/adminProductDetails";
import OrderDetails from "../../views/admin/order/details";
import UserManagement from "../../views/admin/userManagement";
import EditUser from "../../views/admin/userManagement/EditUser";
import UserStatistics from "../../views/admin/userStatistics";
import Ticket from "../../views/admin/Ticket";
import EditSubscription from "../../views/admin/subscription/edit";
import Transactions from "../../views/admin/transactions";
import TransactionDetails from "../../views/admin/transactions/TransactionDetails";
import FailedOrders from "../../views/admin/FailedOrders";
import AmazonProductDetail from "../../views/admin/AmazonProductDetail";
import AdminFindSimilar from "../../views/admin/AmazonProductDetail/FindSimilar";
import ProductVariants from "../../views/admin/AmazonProductDetail/ProductVariants";
import TicketManagement from "../../views/admin/ticketManagement";
import RefundDetails from "../../views/admin/ticketManagement/RefundDetails.js";
import AddContent from "../../views/admin/category/existingCategory/addContent/index.js";
import MemebershipManagement from "../../views/admin/membershipManagement/index.js";
import AlibabaMgmt from "../../views/admin/alibaba/index.js";
import AlibabaDetails from "../../views/admin/alibaba/details.js";
import SkuUpload from "../../views/admin/skuUpload";
import PricingAlgo from "../../views/admin/pricingAlgo";
import PricingAlgorithms from "../../views/admin/pricingAlgorithms";
import ProductDraftsList from "../../views/admin/productDrafts";
import ProductErrorList from "../../views/admin/productError";
import ProductErrorDetail from "../../views/admin/productError/ProductErrorDetail";
import EditProductDraft from "../../views/admin/productDrafts/edit";
import ViewProductDraft from "../../views/admin/productDrafts/view";
import Logistics from "../../views/admin/logistics";
import CategoryApproval from "../../views/admin/categoryApproval";
import InternalUsers from "../../views/admin/internalUsers/index";
import ProductDetail from "../../views/admin/internalUsers/productDetail/index";
import FindSimilar from "../../views/admin/internalUsers/findSimilar/index";
import AdminInquiryList from "../../views/admin/inquiries";
import AdminInquiryDetails from "../../views/admin/inquiries/details";
import AdminContactDetails from "../../views/admin/inquiries/ContactDetails";
import CantonFairLeadsAdmin from "../../views/admin/cantonFairLeads";
import SupplierInquiriesAdmin from "../../views/admin/supplierInquiries";
import SearchLog from "../../views/admin/searchLog";
import UserDetails from "../../views/admin/searchLog/userDetails";
import FeaturedCategories from "../../views/admin/featuredCategories";
import EditFeaturedCategory from "../../views/admin/featuredCategories/edit";
import SupplierDataInfo from "../../views/admin/supplierDataInfo";
import SupplierDetail from "../../views/admin/supplierDataInfo/SupplierDetail";
import CronLogs from "../../views/admin/cronLogs";
import CronManagement from "../../views/admin/cronManagement";
import RoleManagement from "../../views/admin/roles";
import CrossBorderOrderManagement from "../../views/admin/crossBorderOrder";
import CrossBorderOrderSummary from "../../views/admin/crossBorderOrder/OrderSummary";
import CrossBorderOrderDetail from "../../views/admin/crossBorderOrder/OrderDetail";
import Tags from "../../views/admin/tags";
import TagProducts from "../../views/admin/tags/TagProducts";
import WarehouseManagement from "../../views/admin/warehouseManagement";
import ShippingManagement from "../../views/admin/shippingManagement";
import ReferralManagement from "../../views/admin/referralManagement";
import ReferralDetail from "../../views/admin/referralManagement/detail";
import CreditManagement from "../../views/admin/createdAmountManagement";
import IMPointsAssign from "../../views/admin/imPointsManagement";
import IMPointsHistory from "../../views/admin/imPointsManagement/TransactionHistory";
import AIManagement from "../../views/admin/aiManagement";
import ModelForm from "../../views/admin/aiManagement/ModelForm";
import PromptForm from "../../views/admin/aiManagement/PromptForm";
import Reports from "../../views/admin/reports";
import ProductExport from "../../views/admin/productExport";
import RestrictedWords from "../../views/admin/restrictedWords";
import RechargeRequests from "../../views/admin/rechargeRequests";
import AffiliateDashboard from "../../views/admin/affiliate/AffiliateDashboard";
import AffiliateManagement from "../../views/admin/affiliate/AffiliateManagement";
import CommissionPlans from "../../views/admin/affiliate/CommissionPlans";
import PayoutSettings from "../../views/admin/affiliate/PayoutSettings";
import WithdrawalApprovals from "../../views/admin/affiliate/WithdrawalApprovals";
import FraudMonitor from "../../views/admin/affiliate/FraudMonitor";
import GlobalCategoryMappingPage from "../../views/admin/category/globalCategoryMappingPage/index.js";
import BankTransferSettings from "../../views/admin/bankTransferSettings";
import AbandonedLeadsList from "../../views/admin/abandonedLeads";
import AbandonedLeadDetail from "../../views/admin/abandonedLeads/LeadDetail";
import AbandonedReminderSettings from "../../views/admin/abandonedLeads/ReminderSettings";
import MapOrders from "../../views/admin/MapOrders";
import MapOrderScraper from "../../views/admin/MapOrders/MapOrderScraper";
import ChinaOrderDetails from "../../views/admin/chinaUpdate/orderDetails";
import PostageToIndia from "../../views/admin/chinaUpdate/postageToIndia";
import INCommentsDashboard from "../../views/admin/chinaUpdate/inComments";

function LegacyBankTransferLeadRedirect() {
  const { id } = useParams();
  return <Navigate to={`/admin/abandoned-leads/payment/${id}`} replace />;
}

const adminRoutes = [
  {
    path: "admin/dashboard",
    element: <AdminDashboardNew />,
    title: "dashboard",
  },

  {
    path: "admin/featured-categories",
    element: <FeaturedCategories />,
    title: "featuredCategories",
  },
  {
    path: "admin/featured-categories/edit",
    element: <EditFeaturedCategory />,
    title: "editFeaturedCategory",
  },


  {
    path: "admin/user-management",
    element: <UserManagement />,
    title: "userManagement",
  },
  {
    path: "admin/user-management/edit-user/:id",
    element: <EditUser />,
    title: "editUser",
  },

  {
    path: "admin/transactions",
    element: <Transactions />,
    title: "transactions",
  },
  {
    path: "admin/credit-management",
    element: <CreditManagement />,
    title: "creditManagement",
  },
  {
    path: "admin/im-points/assign",
    element: <IMPointsAssign />,
    title: "imPointsAssign",
  },
  {
    path: "admin/im-points/transactions",
    element: <IMPointsHistory />,
    title: "imPointsTransactions",
  },
  {
    path: "admin/recharge-requests",
    element: <RechargeRequests />,
    title: "rechargeRequests",
  },
  {
    path: "admin/bank-transfer-settings",
    element: <BankTransferSettings />,
    title: "bankTransferSettings",
  },
  {
    path: "admin/abandoned-leads/reminders",
    element: <AbandonedReminderSettings />,
    title: "abandonedReminders",
  },
  {
    path: "admin/abandoned-leads/:stage/:id",
    element: <AbandonedLeadDetail />,
    title: "abandonedLeadDetail",
  },
  {
    path: "admin/abandoned-leads/:stage",
    element: <AbandonedLeadsList />,
    title: "abandonedLeads",
  },
  {
    path: "admin/bank-transfer-leads",
    element: <Navigate to="/admin/abandoned-leads/payment" replace />,
    title: "abandonedLeads",
  },
  {
    path: "admin/bank-transfer-leads/:id",
    element: <LegacyBankTransferLeadRedirect />,
    title: "abandonedLeadDetail",
  },
  {
    path: "admin/shipping-management",
    element: <ShippingManagement />,
    title: "shippingManagement",
  },

  {
    path: "admin/transaction/:id",
    element: <TransactionDetails />,
    title: "userStatistics",
  },

  {
    path: "admin/user-statistics",
    element: <UserStatistics />,
    title: "userStatistics",
  },

  {
    path: "admin/categories",
    element: <ExistingCategory />,
    title: "category",
  },
  {
    path: "admin/categories/content",
    element: <AddContent />,
    title: "addContent",
  },
  {
    path: "admin/tags",
    element: <Tags />,
    title: "tags",
  },
  {
    path: "admin/tags/:tag",
    element: <TagProducts />,
    title: "tagProducts",
  },

  {
    path: "admin/order-management",
    element: <OrderManagement />,
    title: "dashboard",
  },
  {
    path: "admin/order-management/details/:id",
    element: <OrderDetails />,
    title: "dashboard",
  },

  {
    path: "admin/ticket-management",
    element: <TicketManagement />,
    title: "dashboard",
  },
  {
    path: "/admin/ticket-management/ticket/:id",
    element: <Ticket />,
    title: "ticket",
  },
  {
    path: "admin/ticket-management/refund/:id",
    element: <RefundDetails />,
    title: "dashboard",
  },

  {
    path: "admin/failed-orders",
    element: <FailedOrders />,
    title: "userStatistics",
  },
  {
    path: "admin/amazon-product",
    element: <AmazonProductDetail />,
    title: "amazonProductDetail",
  },
  {
    path: "admin/amazon-product/find-similar",
    element: <AdminFindSimilar />,
    title: "amazonProductFindSimilar",
  },
  {
    path: "admin/amazon-product/variants",
    element: <ProductVariants />,
    title: "amazonProductVariants",
  },

  {
    path: "admin/subscription/add",
    element: <AddSubscription />,
    title: "dashboard",
  },
  {
    path: "admin/subscription/list",
    element: <SubscriptionList />,
    title: "dashboard",
  },
  {
    path: "admin/subscription/edit",
    element: <EditSubscription />,
    title: "dashboard",
  },

  {
    path: "admin/products/add",
    element: <AddProduct />,
    title: "addProduct",
  },
  {
    path: "admin/products/list",
    element: <ProductList />,
    title: "productList",
  },
  {
    path: "admin/products/edit/:id",
    element: <EditProduct />,
    title: "editProduct",
  },
  {
    path: "admin/products/details",
    element: <AdminProductDetails />,
    title: "productDetails",
  },

  {
    path: "admin/membership-management",
    element: <MemebershipManagement />,
    title: "addContent",
  },
  {
    path: "admin/alibaba-product",
    element: <AlibabaMgmt />,
    title: "alibaba",
  },
  {
    path: "admin/alibaba/details",
    element: <AlibabaDetails />,
    title: "alibabaDetails",
  },
  {
    path: "admin/sku-upload",
    element: <SkuUpload />,
    title: "skuUpload",
  },
  {
    path: "admin/pricing-algo",
    element: <PricingAlgo />,
    title: "pricingAlgo",
  },
  {
    path: "admin/pricing-algorithms",
    element: <PricingAlgorithms />,
    title: "pricingAlgorithms",
  },
  {
    path: "admin/product-drafts",
    element: <ProductDraftsList />,
    title: "productDrafts",
  },
  {
    path: "admin/product-errors",
    element: <ProductErrorList />,
    title: "productErrors",
  },
  {
    path: "admin/product-errors/details",
    element: <ProductErrorDetail />,
    title: "productErrorDetails",
  },
  {
    path: "admin/product-errors/:id",
    element: <ProductErrorDetail />,
    title: "productErrorDetail",
  },
  {
    path: "admin/product-drafts/edit/:id",
    element: <EditProductDraft />,
    title: "editProductDraft",
  },
  {
    path: "admin/product-drafts/view/:id",
    element: <ViewProductDraft />,
    title: "viewProductDraft",
  },
  {
    path: "admin/inquiries",
    element: <AdminInquiryList />,
    title: "inquiryList",
  },
  {
    path: "admin/inquiries/:id",
    element: <AdminInquiryDetails />,
    title: "inquiryDetails",
  },
  {
    path: "admin/canton-fair-leads",
    element: <CantonFairLeadsAdmin />,
    title: "cantonFairLeads",
  },
  {
    path: "admin/supplier-inquiries",
    element: <SupplierInquiriesAdmin />,
    title: "supplierInquiries",
  },
  {
    path: "admin/contacts",
    element: <AdminInquiryList />,
    title: "contactInquiryList",
  },
  {
    path: "/admin/contacts/:id",
    element: <AdminContactDetails />,
    title: "contactInquiryDetails",
  },
  {
    path: "admin/search-log",
    element: <SearchLog />,
    title: "searchLog",
  },
  {
    path: "admin/search-log/user-details",
    element: <UserDetails />,
    title: "userDetails",
  },
  {
    path: "admin/logistics",
    element: <Logistics />,
    title: "logistics",
  },
  {
    path: "admin/category-approval",
    element: <CategoryApproval />,
    title: "categoryApproval",
  },
  {
    path: "admin/internal-users",
    element: <InternalUsers />,
    title: "internalUsers",
  },
  {
    path: "admin/internal-users/search",
    element: <InternalUsers />,
    title: "internalUsers",
  },
  {
    path: "admin/internal-users/product-detail",
    element: <ProductDetail />,
    title: "internalUsersProductDetail",
  },
  {
    path: "admin/internal-users/find-similar",
    element: <FindSimilar />,
    title: "internalUsersFindSimilar",
  },
  {
    path: "admin/supplier-data-info",
    element: <SupplierDataInfo />,
    title: "supplierDataInfo",
  },
  {
    path: "admin/supplier-data-info/:sellerOpenId",
    element: <SupplierDetail />,
    title: "supplierDetail",
  },
  {
    path: "admin/cron-logs",
    element: <CronLogs />,
    title: "cronLogs",
  },
  {
    path: "admin/cron-management",
    element: <CronManagement />,
    title: "cronManagement",
  },
  {
    path: "admin/roles",
    element: <RoleManagement />,
    title: "roleManagement",
  },
  {
    path: "admin/cross-border-orders",
    element: <CrossBorderOrderManagement />,
    title: "crossBorderOrders",
  },
  {
    path: "admin/cross-border-orders/summary",
    element: <CrossBorderOrderSummary />,
    title: "crossBorderOrderSummary",
  },
  {
    path: "admin/cross-border-orders/:id",
    element: <CrossBorderOrderDetail />,
    title: "crossBorderOrderDetail",
  },
  {
    path: "admin/warehouse-management",
    element: <WarehouseManagement />,
    title: "warehouseManagement",
  },
  {
    path: "admin/referral-management",
    element: <ReferralManagement />,
    title: "referralManagement",
  },
  {
    path: "admin/referral-management/:id",
    element: <ReferralDetail />,
    title: "referralDetail",
  },
  {
    path: "admin/ai-management",
    element: <AIManagement />,
    title: "aiManagement",
  },
  {
    path: "admin/ai-management/models/new",
    element: <ModelForm />,
    title: "addAIModel",
  },
  {
    path: "admin/ai-management/models/:id",
    element: <ModelForm />,
    title: "editAIModel",
  },
  {
    path: "admin/ai-management/prompts/new",
    element: <PromptForm />,
    title: "addAIPrompt",
  },
  {
    path: "admin/ai-management/prompts/:id",
    element: <PromptForm />,
    title: "editAIPrompt",
  },
  {
    path: "admin/reports",
    element: <Reports />,
    title: "reports",
  },
  {
    path: "admin/product-export",
    element: <ProductExport />,
    title: "productExport",
  },
  {
    path: "admin/restricted-words",
    element: <RestrictedWords />,
    title: "restrictedWords",
  },
  {
    path: "admin/affiliate-dashboard",
    element: <AffiliateDashboard />,
    title: "affiliateDashboard",
  },
  {
    path: "admin/affiliate-management",
    element: <AffiliateManagement />,
    title: "affiliateManagement",
  },
  {
    path: "admin/commission-plans",
    element: <CommissionPlans />,
    title: "commissionPlans",
  },
  {
    path: "admin/payout-settings",
    element: <PayoutSettings />,
    title: "payoutSettings",
  },
  {
    path: "admin/withdrawal-approvals",
    element: <WithdrawalApprovals />,
    title: "withdrawalApprovals",
  },
  {
    path: "admin/fraud-monitor",
    element: <FraudMonitor />,
    title: "fraudMonitor",
  },
  {
    path: "admin/global-category-mapping",
    element: <GlobalCategoryMappingPage />,
    title: "globalCategoryMapping",
  },
  {
    path: "admin/map-orders",
    element: <MapOrders />,
    title: "mapOrders",
  },
  {
    path: "admin/map-order-scraper",
    element: <MapOrderScraper />,
    title: "mapOrderScraper",
  },
  {
    path: "admin/china-update/order-details",
    element: <ChinaOrderDetails />,
    title: "chinaOrderDetails",
  },
  {
    path: "admin/china-update/postage-to-india",
    element: <PostageToIndia />,
     title: "postageToIndia",
  },
  {
    path: "admin/china-update/in-comments",
    element: <INCommentsDashboard />,
    title: "inCommentsDashboard",
  },
];

export default adminRoutes;
